import { Chip, Palette } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StatusChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "backgroundColor" && prop !== "fontColor"
})<{ backgroundColor?: string; color?: keyof Palette, fontColor?: string }>(
  ({ theme, backgroundColor, color, fontColor }) => ({
    fontWeight: 600,
    "& .MuiChip-label": {
      padding: theme.spacing(1, 2)
    },
    backgroundColor:
      backgroundColor ||
      (color && theme.palette[color] && "100" in theme.palette[color]
        ? (theme.palette[color] as any)[100]
        : undefined),
    color: fontColor || theme.palette.text.primary,
    borderRadius: "4px"
  })
)

StatusChip.defaultProps = { size: "small" }